import { render, staticRenderFns } from "./agGridModular.vue?vue&type=template&id=1210c801&"
import script from "./agGridModular.vue?vue&type=script&lang=js&"
export * from "./agGridModular.vue?vue&type=script&lang=js&"
import style0 from "./agGridModular.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports